// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M14.07 9C13.56 12.1 10.8 14.31 7.66 14.14C4.53 13.97 2.03 11.47 1.86 8.34C1.69 5.2 3.9 2.44 7 1.93C7.17 1.9 7.35 1.99 7.43 2.14C7.52 2.3 7.5 2.49 7.38 2.62C5.93 4.31 6.02 6.83 7.59 8.41C9.17 9.98 11.69 10.07 13.38 8.62C13.51 8.5 13.7 8.48 13.86 8.57C14.01 8.65 14.1 8.83 14.07 9Z',
];
